import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"position":"absolute","top":"5px"}
}

import { computed } from 'vue';
import { isEmpty } from '../../common/utils/validateUtils';

interface FormatItemSelect {
  label: string;
  value: string;
}

interface Props {
  number: number;
  value: string;
  error?: boolean;
  options: FormatItemSelect[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FormatItemSelects',
  props: {
    number: {},
    value: {},
    error: { type: Boolean, default: false },
    options: {}
  },
  emits: ['selectItem'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// プルダウン選択値
const selectItem = computed({
  get: () => props.value,
  set: (value) => {
    emit('selectItem', value || '');
  },
});

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    modelValue: selectItem.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectItem).value = $event)),
    options: props.options,
    outlined: "",
    dense: "",
    clearable: "",
    "emit-value": "",
    "map-options": "",
    error: props.error,
    "hide-bottom-space": "",
    style: {"background":"var(--q-white)","max-width":"580px"},
    rules: [(val) => (props.number === 1 ? _unref(isEmpty)(val) || _ctx.$t('validation.required') : true)]
  }, {
    default: _withCtx(() => [
      (!selectItem.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "text-dark" }, "選択してください", -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "options", "error", "rules"]))
}
}

})